import { getDoiURL, getPubmedURL, formatAuthor } from "../common"

const authors = (item: any) =>
  item.article && item.article.authors
    ? item.article.authors.map((author: any) => [ "AU", formatAuthor(author) ])
    : []

export { authors }
